// extracted by mini-css-extract-plugin
export default {"carousel":"carousel_carousel__vpKXQ","left":"carousel_left__Y9Hgi","right":"carousel_right__nNWdT","fullscreen":"carousel_fullscreen__Denq8","index":"carousel_index__fR6C3"};